module.exports = {
      id: "ic-heikin-ashi-normal-usage",
      viewBox: "0 0 16 16",
      url: __webpack_public_path__ + "sprite-dbc6d5.smartcharts.svg#ic-heikin-ashi-normal-usage",
      toString: function () {
        return this.url;
      }
    }